import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {IconWithoutColor} from '@components/main-menu/components/icon-without-color'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {useCreateGroup} from '../../handlers/use-create-group'
import {TwItem} from './containers'

export const CreateGroupChatButton = observer(() => {
  const {createGroup} = useCreateGroup()
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    () => {
      forceUpdate()
    }
  )
  const handleClick = () => {
    void Tracking.send(TrackingEvent.leftPanelCreateNewGroupChatClick)
    createGroup()
  }
  return (
    <TwItem onClick={handleClick}>
      <IconWithoutColor icon="IconPlus" size={16} />

      <span>{Lang.msg.createGroupChat}</span>
    </TwItem>
  )
})
